import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { CONDITIONS } from './alertsConstants';

const AlertCreateCard = ({ form, onChange, onCreate }) => {
  const currentUnit = CONDITIONS.find((c) => c.id === form.condition)?.unit;
  return (
    <Card className="mb-8" data-testid="alert-create-card">
      <CardHeader>
        <CardTitle className="text-lg">New Alert</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-4 gap-3">
          <div>
            <label className="text-xs text-gray-600">Symbol</label>
            <Input
              placeholder="AAPL"
              value={form.symbol}
              onChange={(e) => onChange({ ...form, symbol: e.target.value.toUpperCase() })}
              data-testid="alert-symbol-input"
            />
          </div>
          <div>
            <label className="text-xs text-gray-600">Condition</label>
            <select
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm h-10 mt-1"
              value={form.condition}
              onChange={(e) => onChange({ ...form, condition: e.target.value })}
              data-testid="alert-condition-select"
            >
              {CONDITIONS.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-gray-600">Threshold ({currentUnit})</label>
            <Input
              type="number"
              step="0.01"
              placeholder="e.g. 200"
              value={form.threshold}
              onChange={(e) => onChange({ ...form, threshold: e.target.value })}
              data-testid="alert-threshold-input"
            />
          </div>
          <div className="flex items-end">
            <Button
              className="bg-purple-600 hover:bg-purple-700 w-full"
              onClick={onCreate}
              data-testid="alert-create-btn"
            >
              Create Alert
            </Button>
          </div>
        </div>
        <div className="grid md:grid-cols-4 gap-3 mt-3">
          <div className="md:col-span-3">
            <label className="text-xs text-gray-600">Note (optional — included in the notification)</label>
            <Input
              placeholder="e.g. Breakout watch from my journal thesis"
              value={form.note}
              onChange={(e) => onChange({ ...form, note: e.target.value })}
              maxLength={200}
              data-testid="alert-note-input"
            />
          </div>
          <div>
            <label className="text-xs text-gray-600">After triggering</label>
            <select
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm h-10 mt-1"
              value={form.repeat ? 'repeat' : 'once'}
              onChange={(e) => onChange({ ...form, repeat: e.target.value === 'repeat' })}
              data-testid="alert-repeat-select"
            >
              <option value="repeat">Keep alerting (1h cooldown)</option>
              <option value="once">Fire once, then pause</option>
            </select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AlertCreateCard;
